import dayjs from 'dayjs'
import { AdGroupStatus, BudgetCapping } from '../../../__generated__/graphql'
import { isDateWithinThreshold } from '../campaign/campaignBudgetStatus'
import { AdGroupStatusStyledParams } from './useAdGroupStatusStyled'

export type LeftoverBudgetKind = 'day' | 'month' | 'period' | 'overall'

const hasBudgetCapping = (budgetCapping: number | null | undefined): boolean => (budgetCapping ?? 0) > 0

export const isLeftoverBudgetCloseToEnd = (
  kind: LeftoverBudgetKind,
  adGroup: Pick<AdGroupStatusStyledParams, 'budgetCappingType' | 'budgetCapping' | 'endDate'>
): boolean => {
  const { budgetCappingType, budgetCapping, endDate } = adGroup

  switch (kind) {
    case 'day':
      return false
    case 'month':
      return (
        budgetCappingType === BudgetCapping.Monthly &&
        hasBudgetCapping(budgetCapping) &&
        isDateWithinThreshold(dayjs().endOf('month'))
      )
    case 'period':
      return (
        budgetCappingType === BudgetCapping.Period &&
        hasBudgetCapping(budgetCapping) &&
        !!endDate &&
        isDateWithinThreshold(endDate)
      )
    case 'overall':
      return (
        budgetCappingType === BudgetCapping.Overall &&
        hasBudgetCapping(budgetCapping) &&
        !!endDate &&
        isDateWithinThreshold(endDate)
      )
  }
}

export const getLeftoverBudgetValueColor = (
  kind: LeftoverBudgetKind,
  left: number,
  adGroup: AdGroupStatusStyledParams
): 'success.main' | 'warning.main' | 'text.disabled' => {
  if (left <= 0 || adGroup.status === AdGroupStatus.NoBudgetLeft) return 'warning.main'
  if (isLeftoverBudgetCloseToEnd(kind, adGroup)) return 'warning.main'
  if (adGroup.status === AdGroupStatus.Active) return 'success.main'
  return 'text.disabled'
}
